import { GET_IRP_MODE } from "../../constants/ActionTypes";

export const changeIrpMode = (mode) => {
    return {
        type: GET_IRP_MODE, mode
    }
};
